import PanelCollapse from 'src/componentes/panel-collapse';
import {
  FORMULARIO_GLOBAL_QUESTION_TYPES,
  QUESTION_TYPES_WITH_OPTIONS,
  normalizeFormularioGlobalQuestionType,
} from 'src/componentes/formulario-global/FormularioGlobalQuestionTypes';
import GraficoBarrasOpcoes from './GraficoBarrasOpcoes';
import GraficoPizzaOpcoes from './GraficoPizzaOpcoes';
import ListaOpcoes from './ListaOpcoes';
import MatrizResultados from './MatrizResultados';
import { getQuestionFormOrder, ordenarOpcoes } from './utils';

const SINGLE_CHOICE_QUESTION_TYPES = QUESTION_TYPES_WITH_OPTIONS.filter(
  (tipo) => tipo !== FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA
);

const QUESTION_TYPE_LABEL_IDS = {
  [FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA]: 'labelRespostaUnica',
  [FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA]: 'labelMultiplaEscolha',
  [FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS]: 'labelEscalaEstrelas',
  [FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT]: 'labelEscalaLikert',
  [FORMULARIO_GLOBAL_QUESTION_TYPES.NPS]: 'labelNps',
  [FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO]: 'labelSimNao',
  [FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO]: 'labelMatrizSelecao',
};

function PerguntaCard({ intl, ordenacao, pergunta }) {
  const tipoPergunta = normalizeFormularioGlobalQuestionType(
    pergunta.tipoPergunta
  );
  const opcoesOrdenadas = ordenarOpcoes(pergunta.opcoes || [], ordenacao);
  const ehEscolhaUnica = SINGLE_CHOICE_QUESTION_TYPES.includes(tipoPergunta);

  return (
    <PanelCollapse
      contentMarginTop={0}
      header={
        <span className="tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:justify-between tw:gap-3">
          <span className="tw:min-w-0 tw:text-[13px] tw:leading-4.5 tw:font-bold tw:text-[#202124] tw:wrap-anywhere">
            {getQuestionFormOrder(pergunta)}. {pergunta.titulo}
          </span>
          <span className="tw:shrink-0 tw:rounded-full tw:bg-[#e8f3f5] tw:px-2.75 tw:py-1.25 tw:text-[11px] tw:font-semibold tw:text-[#1d7789]">
            {intl.formatMessage({ id: QUESTION_TYPE_LABEL_IDS[tipoPergunta] })}
          </span>
        </span>
      }
      hideShadow
      noPadding
      className="tw:mb-2.5! tw:overflow-hidden tw:rounded-[10px]! tw:border! tw:border-solid tw:border-[#dfe3e8]! tw:bg-white! tw:p-0!"
      headerStyle="tw:mb-0! tw:flex tw:items-center tw:px-5! tw:py-4!"
    >
      {tipoPergunta === FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO ? (
        <MatrizResultados intl={intl} pergunta={pergunta} />
      ) : ehEscolhaUnica ? (
        <div className="tw:grid tw:grid-cols-[minmax(180px,220px)_minmax(0,1fr)] tw:items-center tw:gap-6 tw:px-5.5 tw:pt-3.5 tw:pb-5 tw:max-[900px]:grid-cols-1">
          <GraficoPizzaOpcoes
            intl={intl}
            opcoes={opcoesOrdenadas}
            titulo={pergunta.titulo}
          />
          <ListaOpcoes
            exibirCores
            intl={intl}
            opcoes={opcoesOrdenadas}
            pergunta={pergunta}
            tipoPergunta={tipoPergunta}
          />
        </div>
      ) : tipoPergunta === FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA ? (
        <GraficoBarrasOpcoes
          intl={intl}
          opcoes={opcoesOrdenadas}
          pergunta={pergunta}
        />
      ) : (
        <ListaOpcoes
          intl={intl}
          opcoes={opcoesOrdenadas}
          pergunta={pergunta}
          tipoPergunta={tipoPergunta}
        />
      )}
    </PanelCollapse>
  );
}

export default PerguntaCard;
